import { DisplayText } from '@garnish/core';

import {
  JoinSgRewards,
  LoyaltyBag,
  LoyaltyFAQ,
  LoyaltyFAQEntry,
  LoyaltyHome,
  LoyaltyHowItWorks,
  LoyaltyIconSgReward,
  LoyaltyInfoBenefits,
  LoyaltyOfferCard,
  LoyaltyOffers,
  LoyaltyPointsHistory,
  LoyaltyTerms,
  ScanAtCheckoutFooter,
  ScanAtCheckoutFooterText,
  ScanAtCheckoutHeader,
  ScanAtCheckoutHowItWorks,
  ScanAtCheckoutRewardOptionsModal,
} from './components';
export * from './utils';
export * from './hooks';

export const Loyalty = {
  Bag: LoyaltyBag,
  Home: LoyaltyHome,
  FAQ: LoyaltyFAQ,
  FAQEntry: LoyaltyFAQEntry,
  HowItWorks: LoyaltyHowItWorks,
  InfoBenefits: LoyaltyInfoBenefits,
  PointsHistory: LoyaltyPointsHistory,
  IconSgReward: LoyaltyIconSgReward,
  Terms: LoyaltyTerms,
  JoinSgRewards,
  Offers: LoyaltyOffers,
  OfferCard: LoyaltyOfferCard,
};

export const ScanAtCheckout = {
  Header: ScanAtCheckoutHeader,
  HeaderTitle: DisplayText,
  Footer: ScanAtCheckoutFooter,
  FooterText: ScanAtCheckoutFooterText,
  HowItWorks: ScanAtCheckoutHowItWorks,
  RewardOptionsModal: ScanAtCheckoutRewardOptionsModal,
};

export {
  useInitLoyaltyOffersModalMachine,
  useLoyaltyOffersModalMachine,
  Sweetpass,
} from './components';
export * from './machines';
